module.exports = __webpack_public_path__ + "img/77428.e2e8989e.svg";